// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/leaderboard/leaderboard_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/leaderboard/leaderboard_bg_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/leaderboard/leaderboard_avatar_frame_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/leaderboard/leaderboard_avatar_frame.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rank-table-container {
    flex: 1;
    height: 100%; 
    position: relative; 
} 

.table-empty { 
    position: absolute; 
    width: 400px; 
    left: calc(50% - 200px);  
    top: 30%;
    font-size: 28px; 
    text-align: center;
    color: antiquewhite;
}

.rank-table {
    width: 100%;
    border-collapse: collapse;
    color: #FFFFFF;
}

.rank-table thead tr {
    display: table;
    table-layout: fixed;
    width: 100%;
}

.rank-table thead tr th:nth-child(1) {
    width: 152px; 
    text-align: left;
} 

.rank-table thead tr th:nth-child(1) > div { 
    width: 78px; 
    /* background-color: tomato;  */
    text-align: center;
} 

.rank-table thead tr th:nth-child(2) {
    width: 172px; 
    text-align: left;
} 

.rank-table thead tr th { 
    width: 126px;
    padding: 4px 0;
    font-size: 14px;
    text-transform: capitalize; 
    border-bottom: 1px solid #ffa600;
    cursor: pointer; 
    text-align: center;
} 

.rank-table thead tr th > div {
    text-align: center;
}

.rank-table .thead-sort-icon {
    width: 8px;
    height: 8px;
    margin-left: 4px;
}

.rank-table tbody {
    display: block;
    height: 540px;
    overflow-y: auto;
    border-collapse: collapse;
}

.rank-table tbody tr {
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    display: table;
    width: 100%;
    margin-top: 8px;
}

.rank-table tbody tr td:nth-child(1) {
    width: 152px;
} 

.rank-table tbody tr td:nth-child(2) { 
    width: 172px;
}

.rank-table tbody tr:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.rank-table tbody tr:hover .rank-row-avatar {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.rank-table tbody tr td {
    width: 126px; 
    text-align: center;
}

.rank-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    gap: 10px;
    position: relative;
}

.rank-row .rank-row-number {
    background-size: 100% 100%;
    width: 46px;
    height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.rank-row-avatar {
    position: absolute;
    left: 64px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 100% 100%;
    width: 48px;
    height: 48px; 
    border: 1px solid #35b0c5; 
    border-radius: 4px;
}

.rank-row-upgrade {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 2;
}

.rank-row-win {
    color: #ffa600;
}

.rank-row-winRatio {
    color: #35b0c5;
}

.rank-row-reward img {
    width: 48px;
    height: 40px;
}

.clickable-row {
    cursor: pointer;
    transition: filter 0.2s ease;
}

.clickable-row:hover {
    filter: brightness(1.2);
}

.rank-table tr {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}`, "",{"version":3,"sources":["webpack://./src/components/leaderboardTable/LeaderboardTable.style.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yDAA+D;IAC/D,0BAA0B;IAC1B,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yDAAsE;AAC1E;;AAEA;IACI,yDAAgF;AACpF;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,yDAAyE;IACzE,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;AAC/B","sourcesContent":[".rank-table-container {\n    flex: 1;\n    height: 100%; \n    position: relative; \n} \n\n.table-empty { \n    position: absolute; \n    width: 400px; \n    left: calc(50% - 200px);  \n    top: 30%;\n    font-size: 28px; \n    text-align: center;\n    color: antiquewhite;\n}\n\n.rank-table {\n    width: 100%;\n    border-collapse: collapse;\n    color: #FFFFFF;\n}\n\n.rank-table thead tr {\n    display: table;\n    table-layout: fixed;\n    width: 100%;\n}\n\n.rank-table thead tr th:nth-child(1) {\n    width: 152px; \n    text-align: left;\n} \n\n.rank-table thead tr th:nth-child(1) > div { \n    width: 78px; \n    /* background-color: tomato;  */\n    text-align: center;\n} \n\n.rank-table thead tr th:nth-child(2) {\n    width: 172px; \n    text-align: left;\n} \n\n.rank-table thead tr th { \n    width: 126px;\n    padding: 4px 0;\n    font-size: 14px;\n    text-transform: capitalize; \n    border-bottom: 1px solid #ffa600;\n    cursor: pointer; \n    text-align: center;\n} \n\n.rank-table thead tr th > div {\n    text-align: center;\n}\n\n.rank-table .thead-sort-icon {\n    width: 8px;\n    height: 8px;\n    margin-left: 4px;\n}\n\n.rank-table tbody {\n    display: block;\n    height: 540px;\n    overflow-y: auto;\n    border-collapse: collapse;\n}\n\n.rank-table tbody tr {\n    cursor: pointer;\n    background-image: url('@assets/leaderboard/leaderboard_bg.png');\n    background-size: 100% 100%;\n    display: table;\n    width: 100%;\n    margin-top: 8px;\n}\n\n.rank-table tbody tr td:nth-child(1) {\n    width: 152px;\n} \n\n.rank-table tbody tr td:nth-child(2) { \n    width: 172px;\n}\n\n.rank-table tbody tr:hover {\n    background-image: url('@assets/leaderboard/leaderboard_bg_active.png');\n}\n\n.rank-table tbody tr:hover .rank-row-avatar {\n    background-image: url('@assets/leaderboard/leaderboard_avatar_frame_active.png');\n}\n\n.rank-table tbody tr td {\n    width: 126px; \n    text-align: center;\n}\n\n.rank-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 16px;\n    gap: 10px;\n    position: relative;\n}\n\n.rank-row .rank-row-number {\n    background-size: 100% 100%;\n    width: 46px;\n    height: 46px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.rank-row-avatar {\n    position: absolute;\n    left: 64px;\n    background-image: url('@assets/leaderboard/leaderboard_avatar_frame.png');\n    background-size: 100% 100%;\n    width: 48px;\n    height: 48px; \n    border: 1px solid #35b0c5; \n    border-radius: 4px;\n}\n\n.rank-row-upgrade {\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 24px;\n    height: 24px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    z-index: 2;\n}\n\n.rank-row-win {\n    color: #ffa600;\n}\n\n.rank-row-winRatio {\n    color: #35b0c5;\n}\n\n.rank-row-reward img {\n    width: 48px;\n    height: 40px;\n}\n\n.clickable-row {\n    cursor: pointer;\n    transition: filter 0.2s ease;\n}\n\n.clickable-row:hover {\n    filter: brightness(1.2);\n}\n\n.rank-table tr {\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
